import { request } from "services/api/util";

class ProductLineService {
  async getListProductLine(param) {
    const config = {
      method: "get",
      url: `admin/productLine`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ProductLineService();
